// Module
var code = "<a href=\"javascript:;\" class=\"btn green subFormControl\"> <i class=\"fa fa-tree\"></i> Tree </a>";
// Exports
export default code;